// extracted by mini-css-extract-plugin
module.exports = {"infoPopUp":"infoPopUp-dc311025","content":"content-cfe094a0","text":"text-30384f1f"};